<template>
  <div class="qrcode-tab-wrapper">
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      height="calc(100vh - 210px)"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55"
      ></el-table-column>
      <el-table-column
        label="名称"
        prop="name"
        width="350"
      ></el-table-column>
      <el-table-column
        label="二维码"
        prop="name"
        width="220"
      >
        <template #default="scope">
          <img
            v-preventReClick="3000"
            alt="二维码"
            class="qrcode-tab-icon"
            src="../../assets/images/icon/icon_table_qrcode.png"
            @click="getQRCodeDetail(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="扫码次数"
        prop="qrcodeNum"
        width="220"
      ></el-table-column>
      <el-table-column
        label="操作"
        prop="address"
        show-overflow-tooltip
      >
        <template #default="scope">
          <!--          <img-->
          <!--            alt="打印"-->
          <!--            class="opinion-tab-btn icon-left"-->
          <!--            src="../../assets/images/icon/icon_table_printer.png"-->
          <!--            title="打印"-->
          <!--          />-->

          <img
            alt="编辑"
            class="opinion-tab-btn icon-left"
            src="../../assets/images/icon/icon_table_modify.png"
            title="编辑"
            @click="modifyQrcode(scope.row)"
          />
          <img
            alt="删除"
            class="opinion-tab-btn"
            src="../../assets/images/icon/icon_table_delete.png"
            title="删除"
            @click="deleteQrcode(scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container flex flex-row items-center justify-end">
      <el-pagination
        :current-page="requirementPageIndex"
        :page-size="requirementPageSize"
        :total="dataTotalNum"
        layout="total, sizes, prev, pager, next"
        background
        :page-sizes="sizeList"
        @current-change="currentChange"
        @size-change="pageSizeChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'QrcodeManageTable',
  props: [],
  data() {
    return {
      // 数据列表
      tableData: [],
      // 初始页码
      requirementPageIndex: 1,
      // 一页的数据条数
      requirementPageSize: 10,
      // 数据条数
      dataTotalNum: 0,
      // 加载中标志
      loading: false,
      // 模糊搜索文本
      contentText: '',
			sizeList: [10, 20, 30, 40, 50, 100],
    }
  },
  computed: {
    ...mapState('editor', {
      QRCodeType: state => state.QRCodeType,
    }),
  },
  watch: {
    QRCodeType(val) {
      if (val) {
        this.contentText = ''
        this.initQRCodeData()
      }
    },
  },
  mounted() {
		this.contentText = ''
		this.initQRCodeData()
	},
  methods: {
    ...mapMutations('editor', ['setQRCodeID', 'setEditorStatus']),
    ...mapMutations(['setRouter']),
    /**
     * 初始表格请求数据
     */
    initQRCodeData() {
      this.requirementPageIndex = 1
      this.requirementPageSize = 10
      this.getQRCodeData()
    },
    /**
     * 获取列表数据
     * @returns {Promise<void>}
     */
    async getQRCodeData() {
      this.loading = true
      const { success, data } = await this.$http({
        url: this.$api.pageQueryQrcodeInfo,
        method: 'post',
        data: {
          PageSize: this.requirementPageSize,
          PageIndex: this.requirementPageIndex,
          Type: this.QRCodeType,
          Keyword: this.contentText,
        },
      })
      if (success) {
        const { rows, total } = data
        if (rows.length > 0) {
          for (let i = 0; i < rows.length; i++) {
            rows[i].name = rows[i].Name
          }
        }
        this.tableData = rows
        this.dataTotalNum = total
      }
      this.loading = false
    },
    /**
     *多选框点击事件
     @parma select {array} 选中的数组
     */
    handleSelectionChange() {},
    /**
     * 删除二维码
     * @param row {array} 行数据
     */
    deleteQrcode(row) {
      this.$confirm('确定要删除这个二维码?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'qrcode_modal_confirm_btn',
        cancelButtonClass: 'qrcode_modal_cancel_btn',
      })
        .then(async () => {
          await this.commitDelete(row.ID)
        })
        .catch(() => {})
    },
    /**
     * 提交删除二维码接口
     * @param  ID {number} ID
     */
    async commitDelete(ID) {
      const { success } = await this.$http({
        url: this.$api.deleteQRCode,
        method: 'delete',
        params: {
          qrcodeID: ID,
        },
      })
      if (success) {
        await this.getQRCodeData()
      }
      this.$message({
        type: success ? 'success' : 'error',
        message: success ? '删除成功!' : '删除失败',
      })
    },
    /**
     * 点击编辑icon
     * @param row {array} 行数据
     */
    modifyQrcode(row) {
      this.setQRCodeID(row.ID)
      this.setRouter({ name: 'Editor' })
      this.setEditorStatus('edit')
    },
    /**
     * 获取二维码详情
     * @param row.ID {number} QRCodeID
     */
    async getQRCodeDetail(row) {
      let imageURL = ''
      const { success, data } = await this.$http({
        url: this.$api.getQRCodeDetail,
        params: {
          qrcodeID: row.ID,
        },
      })

      if (success) {
        const { PosterPath } = data
        imageURL = `${WEB_CONFIG.BASE_URL}/${PosterPath}`
      }
      this.showQrcode(imageURL)
    },
    /**
     * 点击二维码icon,显示二维码图片
     * @param imageURL {string} 海报地址
     */
    showQrcode(imageURL) {
      this.$alert(
        `<img  src="${imageURL}" style="display:block;margin:0px auto;width:400px" alt="二维码海报"></img>`,
        '二维码',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '导出',
          confirmButtonClass: 'qrcode_modal_confirm_btn',
          showCancelButton: false,
        },
      ).catch(() => {})
    },
    /**
     * 分页改变
     * @param current {number} 页码
     */
    currentChange(current) {
      this.requirementPageIndex = current
      this.getQRCodeData()
    },
    /**
     * 每页条数改变
     * @param num {number}每页条数
     */
    pageSizeChange(num) {
      this.requirementPageSize = num
      this.getQRCodeData()
    },
    /*
     * 监听父组件点击搜索框
     * @param text {string} 文本
     * */
    searchQrcodeByText(text) {
      this.contentText = text
      this.initQRCodeData()
    },
  },
}
</script>
<style scoped>
.qrcode-panel__body {
  height: calc(100% - 60px);
}
.opinion-tab-btn {
  width: 26px;
  height: 26px;
  cursor: pointer;
}

.icon-left {
  margin-right: 12px;
}

.qrcode-tab-icon {
  width: 16px;
  height: 16px;
}
</style>
